/*eslint eqeqeq: [ 0 ]*/
import React, { Component, Fragment } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
// import { Link } from 'react-router-dom';
import { withStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepContent from "@material-ui/core/StepContent";
// import 'typeface-roboto';
import classnames from "classnames";
import Grid from "@material-ui/core/Grid";
// import Button from "@material-ui/core/Button";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
// import MaskedInput from 'react-text-mask';
import Input from "@material-ui/core/Input";
// import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import { Consumer } from "./HomeLoanContext";
import TotalIncome from "../TotalIncome";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
// import TableRow from "@material-ui/core/TableRow";
// import TableCell from "@material-ui/core/TableCell";
// import Edit from "@material-ui/icons/Edit";
import HomeLoansTerms from "../HomeLoansTerms";
import styles from "../ewccstyle";
import {
  StepButtons,
  TinCustom,
  SSSCustom,
  HomeAreaCode,
  HomeTelCustom,
  HomeTelCustom2,
  MobileCustom,
  CurrencyCustom,
  SpecialSelect,
  ZipCustom,
  maxDate,
  minDate,
  ReviewTableRow,
} from "../CommonComponents";
import { Redirect } from "react-router";
import { ewbConfig } from "../../../config";
import {
  citizenshipList,
  civilStatusList,
  typeOfResidenceList,
  educationList,
  typeOfEmploymentList,
  businessNatureList,
  placeOfBusinessList,
  sexList,
  loanTermList,
  loanPurposeList,
  collateralTypeList,
  collateralUseList,
  bankDepositList,
  rankPositionList,
  typeOfJobList,
} from "../LoansSpecialList";

const PersonalInformation = withStyles(styles)(function (props) {
  const { activeStep, handleBack, maxStep, classes } = props;

  return (
    <Consumer>
      {(context) => (
        <Formik
          initialValues={{
            firstname: context.firstname,
            middlename: context.middlename,
            lastname: context.lastname,
            bday: context.bday,
            citizenship: context.citizenship,
            sex: context.sex,
            civilStatus: context.civilStatus,
            spouseName: context.spouseName,
            spouseBday: context.spouseBday,
            spouseEmployer: context.spouseEmployer,
            spouseIncome: context.spouseIncome,
            numberOfDependents: context.numberOfDependents,
            motherMaidenName: context.motherMaidenName,
            cityAddress: context.cityAddress,
            provincialAddress: context.provincialAddress,
            cityMunicipalityProvince: context.cityMunicipalityProvince,
            zipCode: context.zipCode,
            lengthOfStay: context.lengthOfStay,
            typeOfResidence: context.typeOfResidence,
            carOwned: context.carOwned,
            homeAreaCode: context.homeAreaCode,
            homePhone: context.homePhone,
            mobilePhone: context.mobilePhone,
            emailAddress: context.emailAddress,
            education: context.education,
            tin: context.tin,
            sss: context.sss,
            gsis: context.gsis,
          }}
          validationSchema={Yup.object().shape(
            {
              firstname: Yup.string()
                .min(2, "First name too short")
                .max(50, "First name is too long")
                .required("First name is required"),
              middlename: Yup.string()
                .min(2, "Middle name too short")
                .max(50, "Middle name is too long")
                .required("Middle name is required"),
              lastname: Yup.string()
                .min(2, "Last name too short")
                .max(50, "Last name is too long")
                .required("Last name is required"),
              bday: Yup.string().required("Date of birth is required"),
              citizenship: Yup.string().required("Please select citizenship"),
              sex: Yup.string().required("Please select a gender"),
              civilStatus: Yup.string().required(
                "Please select a civil status"
              ),
              motherMaidenName: Yup.string().required(
                "Mother's maiden name is required"
              ),
              cityAddress: Yup.string()
                .min(2, "City address is too short")
                .max(120, "City address is too long")
                .required("City address is required"),
              provincialAddress: Yup.string()
                .min(2, "Provincial address is too short")
                .max(120, "Provincial address is too long")
                .required("Provincial address is required"),
              cityMunicipalityProvince: Yup.string().required(
                "Please select city/municipality/province"
              ),
              lengthOfStay: Yup.string().required(
                "Please select length of stay"
              ),
              typeOfResidence: Yup.string().required(
                "Please select type of residence"
              ),
              homePhone: Yup.string()
                .matches(/\d\d\d-\d\d\d\d/, "Invalid Number")
                .when("homeAreaCode", {
                  is: (homeAreaCode) => homeAreaCode != undefined,
                  then: Yup.string().required("Home Phone Number is required"),
                }),

              homeAreaCode: Yup.string()
                .matches(/\d\d/, "Invalid Area Code")
                .when("homePhone", {
                  is: (homePhone) => homePhone != undefined,
                  then: Yup.string().required("Area Code is required"),
                }),
              mobilePhone: Yup.string()
                .matches(
                  /\(\d\d\)\s\d\d\d-\d\d\d-\d\d\d\d/,
                  "Invalid Mobile Phone Number"
                )
                .required("Mobile Phone Number is required"),
              education: Yup.string().required("Please select education"),
            },
            [["homePhone", "homeAreaCode"]]
          )}
          onSubmit={(values, actions) => {
            context.updateState("firstname", values.firstname);
            context.updateState("middlename", values.middlename);
            context.updateState("lastname", values.lastname);
            context.updateState("bday", values.bday);
            context.updateState("citizenship", values.citizenship);
            context.updateState("sex", values.sex);
            context.updateState("civilStatus", values.civilStatus);
            context.updateState("spouseName", values.spouseName);
            context.updateState("spouseBday", values.spouseBday);
            context.updateState("spouseEmployer", values.spouseEmployer);
            context.updateState("spouseIncome", values.spouseIncome);
            context.updateState(
              "numberOfDependents",
              values.numberOfDependents
            );
            context.updateState("motherMaidenName", values.motherMaidenName);
            context.updateState("cityAddress", values.cityAddress);
            context.updateState("provincialAddress", values.provincialAddress);
            context.updateState(
              "cityMunicipalityProvince",
              values.cityMunicipalityProvince
            );
            context.updateState("zipCode", values.zipCode);
            context.updateState("lengthOfStay", values.lengthOfStay);
            context.updateState("typeOfResidence", values.typeOfResidence);
            context.updateState("carOwned", values.carOwned);

            context.updateState("homeAreaCode", values.homeAreaCode);
            context.updateState("homePhone", values.homePhone);
            context.updateState("mobilePhone", values.mobilePhone);
            context.updateState("emailAddress", values.emailAddress);
            context.updateState("education", values.education);
            context.updateState("tin", values.tin);
            context.updateState("sss", values.sss);
            context.updateState("gsis", values.gsis);
            actions.setSubmitting(false);
            props.handleSubmit();
          }}
        >
          {(props) => {
            const {
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
            } = props;
            return (
              <form>
                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="firstname"
                    label="First Name"
                    value={values.firstname}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.firstname && touched.firstname ? true : false}
                    helperText={touched.firstname ? errors.firstname : ""}
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="middlename"
                    label="Middle Name"
                    value={values.middlename}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.middlename && touched.middlename ? true : false
                    }
                    helperText={touched.middlename ? errors.middlename : ""}
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="lastname"
                    label="Last Name"
                    value={values.lastname}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.lastname && touched.lastname ? true : false}
                    helperText={touched.lastname ? errors.lastname : ""}
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="bday"
                    label="Date of Birth"
                    type="date"
                    // defaultValue="1980-01-24"
                    value={values.bday}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={classes.textField}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      min: minDate,
                      max: maxDate,
                    }}
                    classes={{ root: classes.marginDense }}
                    error={errors.bday && touched.bday ? true : false}
                    helperText={touched.bday ? errors.bday : ""}
                  />
                </FormControl>
                <FormControl
                  fullWidth
                  margin="dense"
                  error={
                    errors.citizenship && touched.citizenship ? true : false
                  }
                >
                  <InputLabel required htmlFor="citizenship">
                    Citizenship
                  </InputLabel>
                  <SpecialSelect
                    id="citizenship"
                    name="citizenship"
                    value={values.citizenship}
                    onChange={setFieldValue}
                    onBlur={handleBlur}
                    options={citizenshipList}
                  />
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.citizenship && touched.citizenship && (
                      <Fragment>{errors.citizenship}</Fragment>
                    )}
                  </FormHelperText>
                </FormControl>
                <FormControl
                  fullWidth
                  margin="dense"
                  error={errors.sex && touched.sex ? true : false}
                >
                  <InputLabel required htmlFor="sex">
                    Sex
                  </InputLabel>
                  <SpecialSelect
                    id="sex"
                    name="sex"
                    value={values.sex}
                    onChange={setFieldValue}
                    onBlur={handleBlur}
                    options={sexList}
                  />

                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.sex && touched.sex && (
                      <Fragment>{errors.sex}</Fragment>
                    )}
                  </FormHelperText>
                </FormControl>
                <FormControl
                  fullWidth
                  margin="dense"
                  error={
                    errors.civilStatus && touched.civilStatus ? true : false
                  }
                >
                  <InputLabel required htmlFor="civilStatus">
                    Civil Status
                  </InputLabel>
                  <SpecialSelect
                    id="civilStatus"
                    name="civilStatus"
                    value={values.civilStatus}
                    onChange={setFieldValue}
                    onBlur={handleBlur}
                    options={civilStatusList}
                  />
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.civilStatus && touched.civilStatus && (
                      <Fragment>{errors.civilStatus}</Fragment>
                    )}
                  </FormHelperText>
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    id="spouseName"
                    label="Spouse Name"
                    value={values.spouseName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.spouseName && touched.spouseName ? true : false
                    }
                    helperText={touched.spouseName ? errors.spouseName : ""}
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    id="spouseBday"
                    label="Birthdate of Spouse"
                    type="date"
                    // defaultValue="1980-01-24"
                    value={values.spouseBday}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={classes.textField}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    classes={{ root: classes.marginDense }}
                    error={
                      errors.spouseBday && touched.spouseBday ? true : false
                    }
                    helperText={touched.spouseBday ? errors.spouseBday : ""}
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    id="spouseEmployer"
                    label="Employer of Spouse"
                    value={values.spouseEmployer}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.spouseEmployer && touched.spouseEmployer
                        ? true
                        : false
                    }
                    helperText={
                      touched.spouseEmployer ? errors.spouseEmployer : ""
                    }
                  />
                </FormControl>
                <FormControl
                  fullWidth
                  margin="dense"
                  error={
                    errors.spouseIncome && touched.spouseIncome ? true : false
                  }
                >
                  <InputLabel htmlFor="spouseIncome">
                    Spouse Monthly Income
                  </InputLabel>
                  <Select
                    native
                    autoWidth={true}
                    value={values.spouseIncome}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    inputProps={{
                      name: "spouseIncome",
                      id: "spouseIncome",
                    }}
                  >
                    <option value="" />
                    <TotalIncome />
                  </Select>
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.spouseIncome && touched.spouseIncome && (
                      <Fragment>{errors.spouseIncome}</Fragment>
                    )}
                  </FormHelperText>
                </FormControl>
                <FormControl
                  fullWidth
                  margin="dense"
                  error={
                    errors.numberOfDependents && touched.numberOfDependents
                      ? true
                      : false
                  }
                >
                  <InputLabel htmlFor="numberOfDependents">
                    Number of Dependents
                  </InputLabel>
                  <Select
                    native
                    autoWidth={true}
                    value={values.numberOfDependents}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    inputProps={{
                      name: "numberOfDependents",
                      id: "numberOfDependents",
                    }}
                  >
                    <option value="" />
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                  </Select>
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.numberOfDependents &&
                      touched.numberOfDependents && (
                        <Fragment>{errors.numberOfDependents}</Fragment>
                      )}
                  </FormHelperText>
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="motherMaidenName"
                    label="Mother's Maiden Name"
                    value={values.motherMaidenName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.motherMaidenName && touched.motherMaidenName
                        ? true
                        : false
                    }
                    helperText={
                      touched.motherMaidenName ? errors.motherMaidenName : ""
                    }
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="cityAddress"
                    label="City Address"
                    value={values.cityAddress}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.cityAddress && touched.cityAddress ? true : false
                    }
                    helperText={touched.cityAddress ? errors.cityAddress : ""}
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="provincialAddress"
                    label="Provincial Address"
                    value={values.provincialAddress}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.provincialAddress && touched.provincialAddress
                        ? true
                        : false
                    }
                    helperText={
                      touched.provincialAddress == true
                        ? errors.provincialAddress
                        : "(input NA if not applicable)"
                    }
                  />
                </FormControl>
                <FormControl
                  fullWidth
                  margin="dense"
                  error={
                    errors.cityMunicipalityProvince &&
                    touched.cityMunicipalityProvince
                      ? true
                      : false
                  }
                >
                  <InputLabel required htmlFor="cityMunicipalityProvince">
                    City/Municipality/Province
                  </InputLabel>
                  <Select
                    native
                    autoWidth={true}
                    value={values.cityMunicipalityProvince}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    inputProps={{
                      name: "cityMunicipalityProvince",
                      id: "cityMunicipalityProvince",
                    }}
                  >
                    <option value="" />
                    <option value="Abra">Abra</option>
                    <option value="Agusan del Norte">Agusan del Norte</option>
                    <option value="Agusan del Sur">Agusan del Sur</option>
                    <option value="Aklan">Aklan</option>
                    <option value="Albay">Albay</option>
                    <option value="Angeles City">Angeles City</option>
                    <option value="Antipolo City">Antipolo City</option>
                    <option value="Antique">Antique</option>
                    <option value="Apayao">Apayao</option>
                    <option value="Aurora">Aurora</option>
                    <option value="Bacolod">Bacolod</option>
                    <option value="Bacolod City">Bacolod City</option>
                    <option value="Baguio">Baguio</option>
                    <option value="Baguio City">Baguio City</option>
                    <option value="Basilan">Basilan</option>
                    <option value="Bataan">Bataan</option>
                    <option value="Batanes">Batanes</option>
                    <option value="Batangas">Batangas</option>
                    <option value="Batangas City">Batangas City</option>
                    <option value="Benguet">Benguet</option>
                    <option value="Biliran">Biliran</option>
                    <option value="Bohol">Bohol</option>
                    <option value="Bukidnon">Bukidnon</option>
                    <option value="Bulacan">Bulacan</option>
                    <option value="Butuan City">Butuan City</option>
                    <option value="Cabanatuan">Cabanatuan</option>
                    <option value="Cabanatuan City">Cabanatuan City</option>
                    <option value="Cagayan">Cagayan</option>
                    <option value="Cagayan De Oro">Cagayan De Oro</option>
                    <option value="Cagayan de Oro City">
                      Cagayan de Oro City
                    </option>
                    <option value="Caloocan City">Caloocan City</option>
                    <option value="Camarines Norte">Camarines Norte</option>
                    <option value="Camarines Sur">Camarines Sur</option>
                    <option value="Camiguin">Camiguin</option>
                    <option value="Capiz">Capiz</option>
                    <option value="Catanduanes">Catanduanes</option>
                    <option value="Cavite">Cavite</option>
                    <option value="Cavite">Cavite</option>
                    <option value="Cavite City">Cavite City</option>
                    <option value="Cebu">Cebu</option>
                    <option value="Cebu City">Cebu City</option>
                    <option value="Compostella Valley">
                      Compostella Valley
                    </option>
                    <option value="Cotabato">Cotabato</option>
                    <option value="Davao">Davao</option>
                    <option value="Davao City">Davao City</option>
                    <option value="Davao del Norte">Davao del Norte</option>
                    <option value="Davao del Sur">Davao del Sur</option>
                    <option value="Davao Oriental">Davao Oriental</option>
                    <option value="Eastern Samar">Eastern Samar</option>
                    <option value="General Santos City">
                      General Santos City
                    </option>
                    <option value="Guimaraz">Guimaraz</option>
                    <option value="Ifugao">Ifugao</option>
                    <option value="Iligan City">Iligan City</option>
                    <option value="Ilocos Norte">Ilocos Norte</option>
                    <option value="Ilocos Sur">Ilocos Sur</option>
                    <option value="Iloilo">Iloilo</option>
                    <option value="Iloilo City">Iloilo City</option>
                    <option value="Isabela">Isabela</option>
                    <option value="Kalinga">Kalinga</option>
                    <option value="La Union">La Union</option>
                    <option value="Laguna">Laguna</option>
                    <option value="Lanao del Norte">Lanao del Norte</option>
                    <option value="Lanao del Sur">Lanao del Sur</option>
                    <option value="Las Pinas City">Las Pinas City</option>
                    <option value="Leyte">Leyte</option>
                    <option value="Lipa city">Lipa city</option>
                    <option value="Lucena">Lucena</option>
                    <option value="Lucena City">Lucena City</option>
                    <option value="Maguindanao">Maguindanao</option>
                    <option value="Makati City">Makati City</option>
                    <option value="Malabon">Malabon</option>
                    <option value="Malabon City">Malabon City</option>
                    <option value="Mandaluyong City">Mandaluyong City</option>
                    <option value="Mandaue City">Mandaue City</option>
                    <option value="Manila">Manila</option>
                    <option value="Marikina City">Marikina City</option>
                    <option value="Marinduque">Marinduque</option>
                    <option value="Masbate">Masbate</option>
                    <option value="Misamis Occidental">
                      Misamis Occidental
                    </option>
                    <option value="Misamis Oriental">Misamis Oriental</option>
                    <option value="Mountain Province">Mountain Province</option>
                    <option value="Muntinlupa City">Muntinlupa City</option>
                    <option value="Naga">Naga</option>
                    <option value="Naga City">Naga City</option>
                    <option value="Negros Occidental">Negros Occidental</option>
                    <option value="Negros Oriental">Negros Oriental</option>
                    <option value="Northern Samar">Northern Samar</option>
                    <option value="Nueva Ecija">Nueva Ecija</option>
                    <option value="Nueva Viscaya">Nueva Viscaya</option>
                    <option value="Occidental Mindoro">
                      Occidental Mindoro
                    </option>
                    <option value="Olongapo">Olongapo</option>
                    <option value="Olongapo City">Olongapo City</option>
                    <option value="Oriental Mindoro">Oriental Mindoro</option>
                    <option value="Ozamiz City">Ozamiz City</option>
                    <option value="Palawan">Palawan</option>
                    <option value="Pampanga">Pampanga</option>
                    <option value="Pangasinan">Pangasinan</option>
                    <option value="Parañaque City">Parañaque City</option>
                    <option value="Pasay City">Pasay City</option>
                    <option value="Pasig City">Pasig City</option>
                    <option value="Quezon">Quezon</option>
                    <option value="Quezon City">Quezon City</option>
                    <option value="Quirino">Quirino</option>
                    <option value="Rizal">Rizal</option>
                    <option value="Romblon">Romblon</option>
                    <option value="Samar">Samar</option>
                    <option value="San Juan">San Juan</option>
                    <option value="San Pablo City">San Pablo City</option>
                    <option value="Santiago City, Isabela">
                      Santiago City, Isabela
                    </option>
                    <option value="Sarangani">Sarangani</option>
                    <option value="Siquijor">Siquijor</option>
                    <option value="Sorsogon">Sorsogon</option>
                    <option value="South Cotabato">South Cotabato</option>
                    <option value="Southern Leyte">Southern Leyte</option>
                    <option value="Sultan Kudarat">Sultan Kudarat</option>
                    <option value="Sulu">Sulu</option>
                    <option value="Surigao del Norte">Surigao del Norte</option>
                    <option value="Surigao del Sur">Surigao del Sur</option>
                    <option value="Tacloban">Tacloban</option>
                    <option value="Tacloban City">Tacloban City</option>
                    <option value="Tagaytay City">Tagaytay City</option>
                    <option value="Tagbilaran City">Tagbilaran City</option>
                    <option value="Taguig">Taguig</option>
                    <option value="Taguig City">Taguig City</option>
                    <option value="Tarlac">Tarlac</option>
                    <option value="Tawi-Tawi">Tawi-Tawi</option>
                    <option value="Urdaneta">Urdaneta</option>
                    <option value="Valenzuela">Valenzuela</option>
                    <option value="Valenzuela City">Valenzuela City</option>
                    <option value="Zambales">Zambales</option>
                    <option value="Zamboanga">Zamboanga</option>
                    <option value="Zamboanga City">Zamboanga City</option>
                    <option value="Zamboanga del Norte">
                      Zamboanga del Norte
                    </option>
                    <option value="Zamboanga del Sur">Zamboanga del Sur</option>
                  </Select>
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.cityMunicipalityProvince &&
                      touched.cityMunicipalityProvince && (
                        <Fragment>{errors.cityMunicipalityProvince}</Fragment>
                      )}
                  </FormHelperText>
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    id="zipCode"
                    label="Zip Code"
                    value={values.zipCode}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.zipCode && touched.zipCode ? true : false}
                    helperText={touched.zipCode ? errors.zipCode : ""}
                    InputProps={{
                      inputComponent: ZipCustom,
                    }}
                  />
                </FormControl>

                <FormControl
                  fullWidth
                  margin="dense"
                  error={
                    errors.lengthOfStay && touched.lengthOfStay ? true : false
                  }
                >
                  <InputLabel required htmlFor="lengthOfStay">
                    Length of stay (years)
                  </InputLabel>
                  <Select
                    native
                    autoWidth={true}
                    value={values.lengthOfStay}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    inputProps={{
                      name: "lengthOfStay",
                      id: "lengthOfStay",
                    }}
                  >
                    <option value="" />
                    <option value="0">0</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                    <option value="21">21</option>
                    <option value="22">22</option>
                    <option value="23">23</option>
                    <option value="24">24</option>
                    <option value="25">25</option>
                    <option value="26">26</option>
                    <option value="27">27</option>
                    <option value="28">28</option>
                    <option value="29">29</option>
                    <option value="30">30</option>
                    <option value="31">31</option>
                    <option value="32">32</option>
                    <option value="33">33</option>
                    <option value="34">34</option>
                    <option value="35">35</option>
                    <option value="36">36</option>
                    <option value="37">37</option>
                    <option value="38">38</option>
                    <option value="39">39</option>
                    <option value="40">40</option>
                    <option value="41">41</option>
                    <option value="42">42</option>
                    <option value="43">43</option>
                    <option value="44">44</option>
                    <option value="45">45</option>
                    <option value="46">46</option>
                    <option value="47">47</option>
                    <option value="48">48</option>
                    <option value="49">49</option>
                    <option value="50">50</option>
                    <option value="51">51</option>
                    <option value="52">52</option>
                    <option value="53">53</option>
                    <option value="54">54</option>
                    <option value="55">55</option>
                    <option value="56">56</option>
                    <option value="57">57</option>
                    <option value="58">58</option>
                    <option value="59">59</option>
                    <option value="60">60</option>
                    <option value="61">61</option>
                    <option value="62">62</option>
                    <option value="63">63</option>
                    <option value="64">64</option>
                    <option value="65">65</option>
                  </Select>
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.lengthOfStay && touched.lengthOfStay && (
                      <Fragment>{errors.lengthOfStay}</Fragment>
                    )}
                  </FormHelperText>
                </FormControl>
                <FormControl
                  fullWidth
                  margin="dense"
                  error={
                    errors.typeOfResidence && touched.typeOfResidence
                      ? true
                      : false
                  }
                >
                  <InputLabel required htmlFor="typeOfResidence">
                    Type of Residence
                  </InputLabel>
                  <SpecialSelect
                    id="typeOfResidence"
                    name="typeOfResidence"
                    value={values.typeOfResidence}
                    onChange={setFieldValue}
                    onBlur={handleBlur}
                    options={typeOfResidenceList}
                  />
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.typeOfResidence && touched.typeOfResidence && (
                      <Fragment>{errors.typeOfResidence}</Fragment>
                    )}
                  </FormHelperText>
                </FormControl>
                <FormControl
                  fullWidth
                  margin="dense"
                  error={errors.carOwned && touched.carOwned ? true : false}
                >
                  <InputLabel htmlFor="carOwned">Car Owned</InputLabel>
                  <Select
                    native
                    autoWidth={true}
                    value={values.carOwned}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    inputProps={{
                      name: "carOwned",
                      id: "carOwned",
                    }}
                  >
                    <option value="" />
                    <option value="0">0</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                  </Select>
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.carOwned && touched.carOwned && (
                      <Fragment>{errors.carOwned}</Fragment>
                    )}
                  </FormHelperText>
                </FormControl>
                <Grid container className={classes.homeNumber}>
                  <FormControl
                    // fullWidth
                    margin="dense"
                    error={errors.homeAreaCode ? true : false}
                  >
                    <InputLabel htmlFor="homeAreaCode">Area Code</InputLabel>
                    <Input
                      // type="number"
                      id="homeAreaCode"
                      value={values.homeAreaCode}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        errors.homeAreaCode && touched.homeAreaCode
                          ? true
                          : false
                      }
                      inputComponent={HomeAreaCode}
                    />
                    <FormHelperText
                      margin="dense"
                      classes={{
                        root: classes.dropdownError,
                        error: classes.error,
                      }}
                      component="p"
                    >
                      {errors.homeAreaCode ||
                        (touched.homeAreaCode && <>{errors.homeAreaCode}</>)}
                    </FormHelperText>
                  </FormControl>
                  <FormControl
                    // fullWidth
                    margin="dense"
                    error={errors.homePhone ? true : false}
                  >
                    <InputLabel htmlFor="homePhone">
                      Home Phone Number
                    </InputLabel>
                    <Input
                      // type="number"
                      id="homePhone"
                      value={values.homePhone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        errors.homePhone && touched.homePhone ? true : false
                      }
                      inputComponent={HomeTelCustom2}
                    />
                    <FormHelperText
                      margin="dense"
                      classes={{
                        root: classes.dropdownError,
                        error: classes.error,
                      }}
                      component="p"
                    >
                      {errors.homePhone ||
                        (touched.homePhone && <>{errors.homePhone}</>)}
                    </FormHelperText>
                  </FormControl>
                </Grid>
                <FormControl
                  fullWidth
                  margin="dense"
                  error={
                    errors.mobilePhone && touched.mobilePhone ? true : false
                  }
                >
                  <InputLabel required htmlFor="mobilePhone">
                    Mobile Phone No
                  </InputLabel>
                  <Input
                    id="mobilePhone"
                    value={values.mobilePhone}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.mobilePhone && touched.mobilePhone ? true : false
                    }
                    inputComponent={MobileCustom}
                  />
                  <FormHelperText
                    classes={{
                      // root: classes.phoneError,
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {/*<Fragment>{touched.mobilePhone == true ? errors.mobilePhone : '(input NA if not applicable)'}</Fragment>*/}
                    {errors.mobilePhone && touched.mobilePhone && (
                      <Fragment>{errors.mobilePhone}</Fragment>
                    )}
                  </FormHelperText>
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    type="email"
                    id="emailAddress"
                    label="Email Address"
                    value={values.emailAddress}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.emailAddress && touched.emailAddress ? true : false
                    }
                    helperText={touched.emailAddress ? errors.emailAddress : ""}
                  />
                </FormControl>
                <FormControl
                  fullWidth
                  margin="dense"
                  error={errors.education && touched.education ? true : false}
                >
                  <InputLabel required htmlFor="education">
                    Education
                  </InputLabel>
                  <SpecialSelect
                    id="education"
                    name="education"
                    value={values.education}
                    onChange={setFieldValue}
                    onBlur={handleBlur}
                    options={educationList}
                  />

                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.education && touched.education && (
                      <Fragment>{errors.education}</Fragment>
                    )}
                  </FormHelperText>
                </FormControl>
                <FormControl
                  fullWidth
                  margin="dense"
                  error={errors.tin && touched.tin ? true : false}
                >
                  <InputLabel htmlFor="tin">TIN No</InputLabel>
                  <Input
                    id="tin"
                    value={values.tin}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.tin && touched.tin ? true : false}
                    inputComponent={TinCustom}
                  />
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.tin && touched.tin && (
                      <Fragment>{errors.tin}</Fragment>
                    )}
                  </FormHelperText>
                </FormControl>
                <FormControl
                  fullWidth
                  margin="dense"
                  error={errors.sss && touched.sss ? true : false}
                >
                  <InputLabel htmlFor="sss">SSS No</InputLabel>
                  <Input
                    id="sss"
                    value={values.sss}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.sss && touched.sss ? true : false}
                    inputComponent={SSSCustom}
                  />
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.sss && touched.sss && (
                      <Fragment>{errors.sss}</Fragment>
                    )}
                  </FormHelperText>
                </FormControl>
                <FormControl
                  fullWidth
                  margin="dense"
                  error={errors.gsis && touched.gsis ? true : false}
                >
                  <InputLabel htmlFor="gsis">GSIS No</InputLabel>
                  <Input
                    id="gsis"
                    value={values.gsis}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.gsis && touched.gsis ? true : false}
                    inputComponent={SSSCustom}
                  />
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.gsis && touched.gsis && (
                      <Fragment>{errors.gsis}</Fragment>
                    )}
                  </FormHelperText>
                </FormControl>
                <StepButtons
                  isSubmitting={isSubmitting}
                  activestep={activeStep}
                  maxstep={maxStep}
                  handleBack={handleBack}
                  handleNext={handleSubmit}
                />
              </form>
            );
          }}
        </Formik>
      )}
    </Consumer>
  );
});

const LoanInformation = withStyles(styles)(function (props) {
  const { activeStep, handleBack, maxStep, classes } = props;

  return (
    <Consumer>
      {(context) => (
        <Formik
          initialValues={{
            loanAmount: context.loanAmount,
            loanTerm: context.loanTerm,
            loanPurpose: context.loanPurpose,
            collateralType: context.collateralType,
            collateralUse: context.collateralUse,
            coborrowersName: context.coborrowersName,
            propertyMortgaged: context.propertyMortgaged,
            bankFinancialInstitution: context.bankFinancialInstitution,
            mortgageAmount: context.mortgageAmount,
            outstandingBalance: context.outstandingBalance,
            monthlyAmortization: context.monthlyAmortization,
          }}
          validationSchema={Yup.object().shape({
            loanAmount: Yup.string()
              .max(16, "Invalid value")
              .required("Please input loan amount"),
            loanTerm: Yup.string().required("Please select loan term"),
            loanPurpose: Yup.string().required("Please select purpose of loan"),
            collateralType: Yup.string().required(
              "Please select type of collateral"
            ),
            propertyMortgaged: Yup.string().required("Please select yes or no"),
            bankFinancialInstitution: Yup.string().when("propertyMortgaged", {
              is: (propertyMortgaged) => propertyMortgaged == "Yes",
              then: Yup.string().required(
                "Please input bank/financial institution"
              ),
            }),
            mortgageAmount: Yup.string()
              .max(16, "Invalid value")
              .when("propertyMortgaged", {
                is: (propertyMortgaged) => propertyMortgaged == "Yes",
                then: Yup.string().required("Please input mortgage amount"),
              }),
            outstandingBalance: Yup.string()
              .max(16, "Invalid value")
              .when("propertyMortgaged", {
                is: (propertyMortgaged) => propertyMortgaged == "Yes",
                then: Yup.string().required(
                  "Please input estimated outstanding balance"
                ),
              }),
            monthlyAmortization: Yup.string()
              .max(16, "Invalid value")
              .when("propertyMortgaged", {
                is: (propertyMortgaged) => propertyMortgaged == "Yes",
                then: Yup.string().required(
                  "Please input monthly amortization"
                ),
              }),
          })}
          onSubmit={(values, actions) => {
            context.updateState("loanAmount", values.loanAmount);
            context.updateState("loanTerm", values.loanTerm);
            context.updateState("loanPurpose", values.loanPurpose);
            context.updateState("collateralType", values.collateralType);
            context.updateState("collateralUse", values.collateralUse);
            context.updateState("coborrowersName", values.coborrowersName);
            context.updateState("propertyMortgaged", values.propertyMortgaged);
            context.updateState(
              "bankFinancialInstitution",
              values.bankFinancialInstitution
            );
            context.updateState("mortgageAmount", values.mortgageAmount);
            context.updateState(
              "outstandingBalance",
              values.outstandingBalance
            );
            context.updateState(
              "monthlyAmortization",
              values.monthlyAmortization
            );
            actions.setSubmitting(false);
            props.handleSubmit();
          }}
        >
          {(props) => {
            const {
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
            } = props;
            return (
              <form>
                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="loanAmount"
                    label="Loan Amount"
                    value={values.loanAmount}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={
                      touched.loanAmount
                        ? errors.loanAmount
                        : "Should match income document submitted"
                    }
                    error={
                      errors.loanAmount && touched.loanAmount ? true : false
                    }
                    InputProps={{
                      inputComponent: CurrencyCustom,
                    }}
                  />
                </FormControl>

                <FormControl
                  fullWidth
                  margin="dense"
                  error={errors.loanTerm && touched.loanTerm ? true : false}
                >
                  <InputLabel required htmlFor="loanTerm">
                    Loan Term
                  </InputLabel>
                  <SpecialSelect
                    id="loanTerm"
                    name="loanTerm"
                    value={values.loanTerm}
                    onChange={setFieldValue}
                    onBlur={handleBlur}
                    options={loanTermList}
                  />
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.loanTerm && touched.loanTerm && (
                      <Fragment>{errors.loanTerm}</Fragment>
                    )}
                  </FormHelperText>
                </FormControl>
                <FormControl
                  fullWidth
                  margin="dense"
                  error={
                    errors.loanPurpose && touched.loanPurpose ? true : false
                  }
                >
                  <InputLabel required htmlFor="loanPurpose">
                    Loan Purpose
                  </InputLabel>
                  <SpecialSelect
                    id="loanPurpose"
                    name="loanPurpose"
                    value={values.loanPurpose}
                    onChange={setFieldValue}
                    onBlur={handleBlur}
                    options={loanPurposeList}
                  />

                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.loanPurpose && touched.loanPurpose && (
                      <Fragment>{errors.loanPurpose}</Fragment>
                    )}
                  </FormHelperText>
                </FormControl>
                <FormControl
                  fullWidth
                  margin="dense"
                  error={
                    errors.collateralType && touched.collateralType
                      ? true
                      : false
                  }
                >
                  <InputLabel required htmlFor="collateralType">
                    Type of Collateral
                  </InputLabel>
                  <SpecialSelect
                    id="collateralType"
                    name="collateralType"
                    value={values.collateralType}
                    onChange={setFieldValue}
                    onBlur={handleBlur}
                    options={collateralTypeList}
                  />

                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.collateralType && touched.collateralType && (
                      <Fragment>{errors.collateralType}</Fragment>
                    )}
                  </FormHelperText>
                </FormControl>

                <FormControl
                  fullWidth
                  margin="dense"
                  error={
                    errors.collateralUse && touched.collateralUse ? true : false
                  }
                >
                  <InputLabel htmlFor="collateralUse">
                    Use of Collateral
                  </InputLabel>
                  <SpecialSelect
                    id="collateralUse"
                    name="collateralUse"
                    value={values.collateralUse}
                    onChange={setFieldValue}
                    onBlur={handleBlur}
                    options={collateralUseList}
                  />
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.collateralUse && touched.collateralUse && (
                      <Fragment>{errors.collateralUse}</Fragment>
                    )}
                  </FormHelperText>
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    id="coborrowersName"
                    label="Co-Borrower's Name"
                    value={values.coborrowersName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.coborrowersName && touched.coborrowersName
                        ? true
                        : false
                    }
                    helperText={
                      touched.coborrowersName ? errors.coborrowersName : ""
                    }
                  />
                </FormControl>
                <FormControl
                  required
                  className={classes.formRadio}
                  fullWidth
                  error={
                    errors.propertyMortgaged && touched.propertyMortgaged
                      ? true
                      : false
                  }
                >
                  <FormLabel component="legend">
                    Is property/collateral presently mortgaged?
                  </FormLabel>
                  <RadioGroup
                    required
                    aria-label=""
                    name="propertyMortgaged"
                    value={values.propertyMortgaged}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.radioError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.propertyMortgaged && touched.propertyMortgaged && (
                      <Fragment>{errors.propertyMortgaged}</Fragment>
                    )}
                  </FormHelperText>
                </FormControl>
                {values.propertyMortgaged == "Yes" ? (
                  <Fragment>
                    <FormControl fullWidth margin="dense">
                      <TextField
                        required
                        id="bankFinancialInstitution"
                        label="Bank/Financial Institution"
                        value={values.bankFinancialInstitution}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={
                          errors.bankFinancialInstitution &&
                          touched.bankFinancialInstitution
                            ? true
                            : false
                        }
                        helperText={
                          touched.bankFinancialInstitution
                            ? errors.bankFinancialInstitution
                            : ""
                        }
                      />
                    </FormControl>
                    <FormControl fullWidth margin="dense">
                      <TextField
                        required
                        id="mortgageAmount"
                        label="Mortgage Amount"
                        value={values.mortgageAmount}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        helperText={
                          touched.mortgageAmount
                            ? errors.mortgageAmount
                            : "Should match income document submitted"
                        }
                        error={
                          errors.mortgageAmount && touched.mortgageAmount
                            ? true
                            : false
                        }
                        InputProps={{
                          inputComponent: CurrencyCustom,
                        }}
                      />
                    </FormControl>
                    <FormControl fullWidth margin="dense">
                      <TextField
                        required
                        id="outstandingBalance"
                        label="Estimated Outstanding Balance"
                        value={values.outstandingBalance}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        helperText={
                          touched.outstandingBalance
                            ? errors.outstandingBalance
                            : "Should match income document submitted"
                        }
                        error={
                          errors.outstandingBalance &&
                          touched.outstandingBalance
                            ? true
                            : false
                        }
                        InputProps={{
                          inputComponent: CurrencyCustom,
                        }}
                      />
                    </FormControl>
                    <FormControl fullWidth margin="dense">
                      <TextField
                        required
                        id="monthlyAmortization"
                        label="Monthly Amortization"
                        value={values.monthlyAmortization}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        helperText={
                          touched.monthlyAmortization
                            ? errors.monthlyAmortization
                            : "Should match income document submitted"
                        }
                        error={
                          errors.monthlyAmortization &&
                          touched.monthlyAmortization
                            ? true
                            : false
                        }
                        InputProps={{
                          inputComponent: CurrencyCustom,
                        }}
                      />
                    </FormControl>
                  </Fragment>
                ) : (
                  ""
                )}
                <StepButtons
                  isSubmitting={isSubmitting}
                  activestep={activeStep}
                  maxstep={maxStep}
                  handleBack={handleBack}
                  handleNext={handleSubmit}
                />
              </form>
            );
          }}
        </Formik>
      )}
    </Consumer>
  );
});

const BankAccounts = withStyles(styles)(function (props) {
  const { activeStep, handleBack, maxStep, classes } = props;

  return (
    <Consumer>
      {(context) => (
        <Formik
          initialValues={{
            bankName: context.bankName,
            bankDeposit: context.bankDeposit,
            bankAccount: context.bankAccount,
          }}
          // Really not wokring
          // validationSchema={Yup.object().shape({
          //   bankName: Yup.string().min(3, "Bank name is too short").max(100, "Bank name is too long").required('Please input bank name'),
          //   bankDeposit: Yup.string().required('Please select deposit type'),
          //   bankAccount: Yup.string().required('Please input bank account number'),
          // })}
          onSubmit={(values, actions) => {
            context.updateState("bankName", values.bankName);
            context.updateState("bankDeposit", values.bankDeposit);
            context.updateState("bankAccount", values.bankAccount);
            actions.setSubmitting(false);
            props.handleSubmit();
          }}
        >
          {(props) => {
            const {
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
            } = props;
            return (
              <form>
                <FormControl fullWidth margin="dense">
                  <TextField
                    id="bankName"
                    label="Bank Name"
                    value={values.bankName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.bankName && touched.bankName ? true : false}
                    helperText={touched.bankName ? errors.bankName : ""}
                  />
                </FormControl>
                <FormControl
                  fullWidth
                  margin="dense"
                  error={
                    errors.bankDeposit && touched.bankDeposit ? true : false
                  }
                >
                  <InputLabel htmlFor="bankDeposit">Bank Deposit</InputLabel>
                  <SpecialSelect
                    id="bankDeposit"
                    name="bankDeposit"
                    value={values.bankDeposit}
                    onChange={setFieldValue}
                    onBlur={handleBlur}
                    options={bankDepositList}
                  />

                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.bankDeposit && touched.bankDeposit && (
                      <Fragment>{errors.bankDeposit}</Fragment>
                    )}
                  </FormHelperText>
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    type="number"
                    id="bankAccount"
                    label="Bank Acct No"
                    value={values.bankAccount}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.bankAccount && touched.bankAccount ? true : false
                    }
                    helperText={touched.bankAccount ? errors.bankAccount : ""}
                  />
                </FormControl>
                <StepButtons
                  isSubmitting={isSubmitting}
                  activestep={activeStep}
                  maxstep={maxStep}
                  handleBack={handleBack}
                  handleNext={handleSubmit}
                />
              </form>
            );
          }}
        </Formik>
      )}
    </Consumer>
  );
});

const EmploymentInformation = withStyles(styles)(function (props) {
  const { activeStep, handleBack, maxStep, classes } = props;
  return (
    <Consumer>
      {(context) => (
        <Formik
          initialValues={{
            typeOfEmployment: context.typeOfEmployment,
            employerName: context.employerName,
            lengthOfService: context.lengthOfService,
            rankPosition: context.rankPosition,
            typeOfJob: context.typeOfJob,
            faxNumber: context.faxNumber,
          }}
          validationSchema={Yup.object().shape({
            typeOfEmployment: Yup.string().required(
              "Please select type of employment"
            ),
            employerName: Yup.string()
              .min(2, "Employer name is too short")
              .max(120, "Employer name is too long")
              .required("Please input employer name"),
            lengthOfService: Yup.string().required(
              "Please select length of service"
            ),
            rankPosition: Yup.string().required("Please select rank/position"),
            typeOfJob: Yup.string().required("Please select type of job"),
          })}
          onSubmit={(values, actions) => {
            context.updateState("typeOfEmployment", values.typeOfEmployment);
            context.updateState("employerName", values.employerName);
            context.updateState("lengthOfService", values.lengthOfService);
            context.updateState("rankPosition", values.rankPosition);
            context.updateState("typeOfJob", values.typeOfJob);
            context.updateState("faxNumber", values.faxNumber);
            actions.setSubmitting(false);
            props.handleSubmit();
          }}
        >
          {(props) => {
            const {
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
            } = props;
            return (
              <form>
                <FormControl
                  fullWidth
                  margin="dense"
                  error={
                    errors.typeOfEmployment && touched.typeOfEmployment
                      ? true
                      : false
                  }
                >
                  <InputLabel required htmlFor="typeOfEmployment">
                    Type of Employment
                  </InputLabel>
                  <SpecialSelect
                    id="typeOfEmployment"
                    name="typeOfEmployment"
                    value={values.typeOfEmployment}
                    onChange={setFieldValue}
                    onBlur={handleBlur}
                    options={typeOfEmploymentList}
                  />

                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.typeOfEmployment && touched.typeOfEmployment && (
                      <Fragment>{errors.typeOfEmployment}</Fragment>
                    )}
                  </FormHelperText>
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="employerName"
                    label="Employer Name"
                    value={values.employerName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.employerName && touched.employerName ? true : false
                    }
                    helperText={
                      touched.employerName == true
                        ? errors.employerName
                        : "(input NA if not applicable)"
                    }
                  />
                </FormControl>
                <FormControl
                  fullWidth
                  margin="dense"
                  error={
                    errors.lengthOfService && touched.lengthOfService
                      ? true
                      : false
                  }
                >
                  <InputLabel required htmlFor="lengthOfService">
                    Length of Service (years)
                  </InputLabel>
                  <Select
                    native
                    autoWidth={true}
                    value={values.lengthOfService}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    inputProps={{
                      name: "lengthOfService",
                      id: "lengthOfService",
                    }}
                  >
                    <option value="" />
                    <option value="0">0</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                    <option value="21">21</option>
                    <option value="22">22</option>
                    <option value="23">23</option>
                    <option value="24">24</option>
                    <option value="25">25</option>
                    <option value="26">26</option>
                    <option value="27">27</option>
                    <option value="28">28</option>
                    <option value="29">29</option>
                    <option value="30">30</option>
                  </Select>
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.lengthOfService && touched.lengthOfService && (
                      <Fragment>{errors.lengthOfService}</Fragment>
                    )}
                  </FormHelperText>
                </FormControl>
                <FormControl
                  fullWidth
                  margin="dense"
                  error={
                    errors.rankPosition && touched.rankPosition ? true : false
                  }
                >
                  <InputLabel required htmlFor="rankPosition">
                    Rank / Position
                  </InputLabel>
                  <SpecialSelect
                    id="rankPosition"
                    name="rankPosition"
                    value={values.rankPosition}
                    onChange={setFieldValue}
                    onBlur={handleBlur}
                    options={rankPositionList}
                  />

                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.phoneError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    <Fragment>
                      {touched.rankPosition
                        ? errors.rankPosition
                        : "(Select NA if not applicable)"}
                    </Fragment>
                  </FormHelperText>
                </FormControl>
                <FormControl
                  fullWidth
                  margin="dense"
                  error={errors.typeOfJob && touched.typeOfJob ? true : false}
                >
                  <InputLabel required htmlFor="typeOfJob">
                    Type of Job{" "}
                  </InputLabel>
                  <SpecialSelect
                    id="typeOfJob"
                    name="typeOfJob"
                    value={values.typeOfJob}
                    onChange={setFieldValue}
                    onBlur={handleBlur}
                    options={typeOfJobList}
                  />

                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.phoneError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    <Fragment>
                      {touched.typeOfJob
                        ? errors.typeOfJob
                        : "(Select NA if not applicable)"}
                    </Fragment>
                  </FormHelperText>
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    // required
                    id="faxNumber"
                    label="Fax No"
                    className={classes.textField}
                    value={values.faxNumber}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    // style={{minWidth: 300}}
                    helperText={touched.faxNumber ? errors.faxNumber : ""}
                    error={errors.faxNumber && touched.faxNumber ? true : false}
                  />
                </FormControl>
                <StepButtons
                  isSubmitting={isSubmitting}
                  activestep={activeStep}
                  maxstep={maxStep}
                  handleBack={handleBack}
                  handleNext={handleSubmit}
                />
              </form>
            );
          }}
        </Formik>
      )}
    </Consumer>
  );
});

const BusinessInformation = withStyles(styles)(function (props) {
  const { activeStep, handleBack, maxStep, classes } = props;
  return (
    <Consumer>
      {(context) => (
        <Formik
          initialValues={{
            businessName: context.businessName,
            businessNature: context.businessNature,
            businessDateRegistered: context.businessDateRegistered,
            businessPhone: context.businessPhone,
            lengthOfOperation: context.lengthOfOperation,
            placeOfBusiness: context.placeOfBusiness,
            monthlyIncome: context.monthlyIncome,
          }}
          validationSchema={Yup.object().shape({
            monthlyIncome: Yup.string()
              .max(16, "Invalid value")
              .required("Please input monthly income"),
            businessPhone: Yup.string().max(30, "Number too long"),
          })}
          onSubmit={(values, actions) => {
            context.updateState("businessName", values.businessName);
            context.updateState("businessNature", values.businessNature);
            context.updateState(
              "businessDateRegistered",
              values.businessDateRegistered
            );
            context.updateState("businessPhone", values.businessPhone);
            context.updateState("lengthOfOperation", values.lengthOfOperation);
            context.updateState("placeOfBusiness", values.placeOfBusiness);
            context.updateState("monthlyIncome", values.monthlyIncome);
            actions.setSubmitting(false);
            props.handleSubmit();
          }}
        >
          {(props) => {
            const {
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
              isSubmitting,
            } = props;
            return (
              <form>
                <FormControl fullWidth margin="dense">
                  <TextField
                    id="businessName"
                    label="Name of Business "
                    value={values.businessName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.businessName && touched.businessName ? true : false
                    }
                    helperText={touched.businessName ? errors.businessName : ""}
                  />
                </FormControl>
                <FormControl
                  fullWidth
                  margin="dense"
                  error={
                    errors.businessNature && touched.businessNature
                      ? true
                      : false
                  }
                >
                  <InputLabel htmlFor="businessNature">
                    Nature of Business{" "}
                  </InputLabel>
                  <SpecialSelect
                    id="businessNature"
                    name="businessNature"
                    value={values.businessNature}
                    onChange={setFieldValue}
                    onBlur={handleBlur}
                    options={businessNatureList}
                  />
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.businessNature && touched.businessNature && (
                      <Fragment>{errors.businessNature}</Fragment>
                    )}
                  </FormHelperText>
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    id="businessDateRegistered"
                    label="Date Registered"
                    type="date"
                    // defaultValue="1980-01-24"
                    value={values.businessDateRegistered}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={classes.textField}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    classes={{ root: classes.marginDense }}
                    error={
                      errors.businessDateRegistered &&
                      touched.businessDateRegistered
                        ? true
                        : false
                    }
                    helperText={
                      touched.businessDateRegistered
                        ? errors.businessDateRegistered
                        : ""
                    }
                  />
                </FormControl>
                <FormControl fullWidth margin="dense">
                  <TextField
                    // required
                    id="businessPhone"
                    label="Phone"
                    className={classes.textField}
                    value={values.businessPhone}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    // style={{minWidth: 300}}
                    helperText={
                      errors.businessPhone && touched.businessPhone
                        ? errors.businessPhone
                        : " If provincial, include area code"
                    }
                    error={
                      errors.businessPhone && touched.businessPhone
                        ? true
                        : false
                    }
                  />
                </FormControl>
                <FormControl
                  fullWidth
                  margin="dense"
                  error={
                    errors.lengthOfOperation && touched.lengthOfOperation
                      ? true
                      : false
                  }
                >
                  <InputLabel htmlFor="lengthOfOperation">
                    Length of Operation (years)
                  </InputLabel>
                  <Select
                    native
                    autoWidth={true}
                    value={values.lengthOfOperation}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    inputProps={{
                      name: "lengthOfOperation",
                      id: "lengthOfOperation",
                    }}
                  >
                    <option value="" />
                    <option value="0">0</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                    <option value="21">21</option>
                    <option value="22">22</option>
                    <option value="23">23</option>
                    <option value="24">24</option>
                    <option value="25">25</option>
                    <option value="26">26</option>
                    <option value="27">27</option>
                    <option value="28">28</option>
                    <option value="29">29</option>
                    <option value="30">30</option>
                    <option value="31">31</option>
                    <option value="32">32</option>
                    <option value="33">33</option>
                    <option value="34">34</option>
                    <option value="35">35</option>
                    <option value="36">36</option>
                    <option value="37">37</option>
                    <option value="38">38</option>
                    <option value="39">39</option>
                    <option value="40">40</option>
                    <option value="41">41</option>
                    <option value="42">42</option>
                    <option value="43">43</option>
                    <option value="44">44</option>
                    <option value="45">45</option>
                    <option value="46">46</option>
                    <option value="47">47</option>
                    <option value="48">48</option>
                    <option value="49">49</option>
                    <option value="50">50</option>
                  </Select>
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.lengthOfOperation && touched.lengthOfOperation && (
                      <Fragment>{errors.lengthOfOperation}</Fragment>
                    )}
                  </FormHelperText>
                </FormControl>
                <FormControl
                  fullWidth
                  margin="dense"
                  error={
                    errors.placeOfBusiness && touched.placeOfBusiness
                      ? true
                      : false
                  }
                >
                  <InputLabel htmlFor="placeOfBusiness">
                    Place of Business
                  </InputLabel>
                  <SpecialSelect
                    id="placeOfBusiness"
                    name="placeOfBusiness"
                    value={values.placeOfBusiness}
                    onChange={setFieldValue}
                    onBlur={handleBlur}
                    options={placeOfBusinessList}
                  />
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.placeOfBusiness && touched.placeOfBusiness && (
                      <Fragment>{errors.placeOfBusiness}</Fragment>
                    )}
                  </FormHelperText>
                </FormControl>
                <FormControl
                  fullWidth
                  margin="dense"
                  error={
                    errors.monthlyIncome && touched.monthlyIncome ? true : false
                  }
                >
                  <InputLabel required htmlFor="monthlyIncome">
                    Total Monthly Income
                  </InputLabel>
                  <Select
                    native
                    autoWidth={true}
                    value={values.monthlyIncome}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    inputProps={{
                      name: "monthlyIncome",
                      id: "monthlyIncome",
                    }}
                  >
                    <option value="" />
                    <TotalIncome />
                  </Select>
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error,
                    }}
                    component="p"
                  >
                    {errors.monthlyIncome && touched.monthlyIncome && (
                      <Fragment>{errors.monthlyIncome}</Fragment>
                    )}
                  </FormHelperText>
                </FormControl>
                <StepButtons
                  isSubmitting={isSubmitting}
                  activestep={activeStep}
                  maxstep={maxStep}
                  handleBack={handleBack}
                  handleNext={handleSubmit}
                />
              </form>
            );
          }}
        </Formik>
      )}
    </Consumer>
  );
});

const ReviewDetails = withStyles(styles)(
  class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        redirect: false,
      };
    }

    render() {
      const { classes, handleEdit, handleBack, activeStep, maxStep } =
        this.props;
      if (this.state.redirect) {
        return <Redirect to="/loans/homeloans/thankyou" />;
        // return (
        //   <Redirect
        //     to={{
        //       pathname: "/loans/homeloans/thankyou",
        //       state: {
        //         referencenumber: Math.floor(Math.random() * 90000) + 10000
        //       }
        //     }}
        //   />
        // );
      }
      return (
        <Consumer>
          {(context) => (
            <Formik
              initialValues={{}}
              onSubmit={(values, actions) => {
                //save form data
                var ewbHLFormData = new FormData();
                ewbHLFormData.append("firstname", context.firstname);
                ewbHLFormData.append("middlename", context.middlename);
                ewbHLFormData.append("lastname", context.lastname);
                ewbHLFormData.append("bday", context.bday);
                ewbHLFormData.append("citizenship", context.citizenship);
                ewbHLFormData.append("sex", context.sex);
                ewbHLFormData.append("civilStatus", context.civilStatus);
                ewbHLFormData.append("spouseName", context.spouseName);
                ewbHLFormData.append("spouseBday", context.spouseBday);
                ewbHLFormData.append("spouseEmployer", context.spouseEmployer);
                ewbHLFormData.append("spouseIncome", context.spouseIncome);
                ewbHLFormData.append(
                  "numberOfDependents",
                  context.numberOfDependents
                );
                ewbHLFormData.append(
                  "motherMaidenName",
                  context.motherMaidenName
                );
                ewbHLFormData.append("cityAddress", context.cityAddress);
                ewbHLFormData.append(
                  "provincialAddress",
                  context.provincialAddress
                );
                ewbHLFormData.append(
                  "cityMunicipalityProvince",
                  context.cityMunicipalityProvince
                );
                ewbHLFormData.append("zipCode", context.zipCode);
                ewbHLFormData.append("lengthOfStay", context.lengthOfStay);
                ewbHLFormData.append(
                  "typeOfResidence",
                  context.typeOfResidence
                );
                ewbHLFormData.append("carOwned", context.carOwned);
                ewbHLFormData.append(
                  "homePhone",
                  `(${context.homeAreaCode.trim()})${context.homePhone}`
                );
                ewbHLFormData.append("mobilePhone", context.mobilePhone);
                ewbHLFormData.append("emailAddress", context.emailAddress);
                ewbHLFormData.append("education", context.education);
                ewbHLFormData.append("tin", context.tin);
                ewbHLFormData.append("sss", context.sss);
                ewbHLFormData.append("gsis", context.gsis);
                ewbHLFormData.append("loanAmount", context.loanAmount);
                ewbHLFormData.append("loanTerm", context.loanTerm);
                ewbHLFormData.append("loanPurpose", context.loanPurpose);
                ewbHLFormData.append("collateralType", context.collateralType);
                ewbHLFormData.append("collateralUse", context.collateralUse);
                ewbHLFormData.append(
                  "coborrowersName",
                  context.coborrowersName
                );
                ewbHLFormData.append(
                  "propertyMortgaged",
                  context.propertyMortgaged
                );
                ewbHLFormData.append(
                  "bankFinancialInstitution",
                  context.bankFinancialInstitution
                );
                ewbHLFormData.append("mortgageAmount", context.mortgageAmount);
                ewbHLFormData.append(
                  "outstandingBalance",
                  context.outstandingBalance
                );
                ewbHLFormData.append(
                  "monthlyAmortization",
                  context.monthlyAmortization
                );
                ewbHLFormData.append("bankName", context.bankName);
                ewbHLFormData.append("bankDeposit", context.bankDeposit);
                ewbHLFormData.append("bankAccount", context.bankAccount);
                ewbHLFormData.append(
                  "typeOfEmployment",
                  context.typeOfEmployment
                );
                ewbHLFormData.append("employerName", context.employerName);
                ewbHLFormData.append(
                  "lengthOfService",
                  context.lengthOfService
                );
                ewbHLFormData.append("rankPosition", context.rankPosition);
                ewbHLFormData.append("typeOfJob", context.typeOfJob);
                ewbHLFormData.append("faxNumber", context.faxNumber);
                ewbHLFormData.append("businessName", context.businessName);
                ewbHLFormData.append("businessNature", context.businessNature);
                ewbHLFormData.append(
                  "businessDateRegistered",
                  context.businessDateRegistered
                );
                ewbHLFormData.append("businessPhone", context.businessPhone);
                ewbHLFormData.append(
                  "lengthOfOperation",
                  context.lengthOfOperation
                );
                ewbHLFormData.append(
                  "placeOfBusiness",
                  context.placeOfBusiness
                );
                ewbHLFormData.append("monthlyIncome", context.monthlyIncome);

                // console.log(ewbHLFormData);

                fetch(ewbConfig.ewbHLFormAPI, {
                  method: "POST",
                  body: ewbHLFormData,
                })
                  .then((response) => {
                    if (response.ok) {
                      // console.log("API Submitting!!!");
                      // window.dataLayer.push({
                      //     'ewformeventcat': 'EW Time Deposit Application Form Submit',
                      //     'ewformeventaction': 'Details successfully saved!',
                      //     'event': 'ewformevent'
                      //   });

                      this.props.handleSubmit(true);
                      actions.setSubmitting(false);
                      context.resetForm();
                      this.setState({
                        redirect: true,
                      });
                      // console.log("API Submit Success!!!");
                    } else {
                      alert(
                        "Unsuccessful form submission. Please make sure your entries are in the correct format before submitting again."
                      );
                      actions.setSubmitting(false);
                    }
                  })
                  .catch((err) => {
                    console.log(err);
                    // this.setState({
                    //   erroralert: true,
                    //   btnDisabled: false
                    // });

                    // window.dataLayer.push({
                    // 	'ewformeventcat': 'EW Time Deposit Application Form Submit',
                    // 	'ewformeventaction': 'API Error!!!',
                    // 	'event': 'ewformevent'
                    // });

                    alert(
                      "Unsuccessful form submission. Please make sure your entries are in the correct format before submitting again."
                    );
                    actions.setSubmitting(false);
                  });
              }}
            >
              {({
                // values,
                // errors,
                // touched,
                // handleChange,
                // handleBlur,
                handleSubmit,
                isSubmitting,
              }) => (
                <div>
                  <Table className={classes.table}>
                    <TableBody>
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="First Name"
                        bodyText={context.firstname}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Middle Name"
                        bodyText={context.middlename}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Last Name"
                        bodyText={context.lastname}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Date of Birth"
                        bodyText={context.bday}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Citizenship"
                        bodyText={context.citizenship.label}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Sex"
                        bodyText={context.sex.label}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Civil Status"
                        bodyText={context.civilStatus.label}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Spouse Name"
                        bodyText={context.spouseName}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Birthdate of Spouse"
                        bodyText={context.spouseBday}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Employer of Spouse"
                        bodyText={context.spouseEmployer}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Spouse Monthly Income"
                        bodyText={context.spouseIncome}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Number of Dependents"
                        bodyText={context.numberOfDependents}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Mother's Maiden Name"
                        bodyText={context.motherMaidenName}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="City Address"
                        bodyText={context.cityAddress}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Provincial Address"
                        bodyText={context.provincialAddress}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="City/Municipality/Province"
                        bodyText={context.cityMunicipalityProvince}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Zip Code"
                        bodyText={context.zipCode}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Length of stay Yrs."
                        bodyText={context.lengthOfStay}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Type of Residence"
                        bodyText={context.typeOfResidence.label}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Car Owned"
                        bodyText={context.carOwned}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Area Code"
                        bodyText={context.homeAreaCode}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Home Phone"
                        bodyText={context.homePhone}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Mobile Phone No"
                        bodyText={context.mobilePhone}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Email Address"
                        bodyText={context.emailAddress}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Education"
                        bodyText={context.education.label}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="TIN No"
                        bodyText={context.tin}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="SSS No"
                        bodyText={context.sss}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="GSIS No"
                        bodyText={context.gsis}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="4"
                        headerText="Loan Amount"
                        bodyText={context.loanAmount}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="4"
                        headerText="Loan Term"
                        bodyText={context.loanTerm.label}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="4"
                        headerText="Loan Purpose"
                        bodyText={context.loanPurpose.label}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="4"
                        headerText="Type of Collateral"
                        bodyText={context.collateralType.label}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="4"
                        headerText="Use of Collateral"
                        bodyText={context.collateralUse.label}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="4"
                        headerText="Co-Borrower's Name"
                        bodyText={context.coborrowersName}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="4"
                        headerText="Is property/collateral presently mortgaged?"
                        bodyText={context.propertyMortgaged}
                      />
                      {context.propertyMortgaged === "Yes" ? (
                        <Fragment>
                          <ReviewTableRow
                            handleEdit={handleEdit}
                            value="4"
                            headerText="Bank/Financial Institution"
                            bodyText={context.bankFinancialInstitution}
                          />
                          <ReviewTableRow
                            handleEdit={handleEdit}
                            value="4"
                            headerText="Mortgage Amount"
                            bodyText={context.mortgageAmount}
                          />
                          <ReviewTableRow
                            handleEdit={handleEdit}
                            value="4"
                            headerText="Estimated Outstanding Balance"
                            bodyText={context.outstandingBalance}
                          />
                          <ReviewTableRow
                            handleEdit={handleEdit}
                            value="4"
                            headerText="Monthly Amortization"
                            bodyText={context.monthlyAmortization}
                          />
                        </Fragment>
                      ) : (
                        ""
                      )}
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="3"
                        headerText="Bank Name"
                        bodyText={context.bankName}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="3"
                        headerText="Bank Deposit"
                        bodyText={context.bankDeposit.label}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="3"
                        headerText="Bank Acct No"
                        bodyText={context.bankAccount}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="2"
                        headerText="Type of Employment"
                        bodyText={context.typeOfEmployment.label}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="2"
                        headerText="Employer Name"
                        bodyText={context.employerName}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="2"
                        headerText="Length of Service Yrs."
                        bodyText={context.lengthOfService}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="2"
                        headerText="Rank / Position"
                        bodyText={context.rankPosition.label}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="2"
                        headerText="Type of Job"
                        bodyText={context.typeOfJob.label}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="2"
                        headerText="Fax No"
                        bodyText={context.faxNumber}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="1"
                        headerText="Name of Business"
                        bodyText={context.businessName}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="1"
                        headerText="Nature of Business"
                        bodyText={context.businessNature.label}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="1"
                        headerText="Date Registered"
                        bodyText={context.businessDateRegistered}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="1"
                        headerText="Business Phone"
                        bodyText={context.businessPhone}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="1"
                        headerText="Length of Operation Yrs."
                        bodyText={context.lengthOfOperation}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="1"
                        headerText="Place of Business"
                        bodyText={context.placeOfBusiness.label}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="1"
                        headerText="Total Monthly Income"
                        bodyText={context.monthlyIncome}
                      />
                    </TableBody>
                  </Table>
                  <article className={classes.termsContainer}>
                    <HomeLoansTerms />
                  </article>

                  <StepButtons
                    isSubmitting={isSubmitting}
                    activestep={activeStep}
                    maxstep={maxStep}
                    handleBack={handleBack}
                    handleNext={handleSubmit}
                  />
                </div>
              )}
            </Formik>
          )}
        </Consumer>
      );
    }
  }
);

function getSteps() {
  return [
    "Personal Information",
    "Loan Information",
    "Bank Accounts",
    "Employment Information",
    "Business Information",
    "Review details",
  ];
}

function ShowContent(props) {
  const { step } = props;
  switch (step) {
    case 0:
      return <PersonalInformation {...props} />;
    case 1:
      return <LoanInformation {...props} />;
    case 2:
      return <BankAccounts {...props} />;
    case 3:
      return <EmploymentInformation {...props} />;
    case 4:
      return <BusinessInformation {...props} />;
    case 5:
      return <ReviewDetails {...props} />;
    default:
      return "Unknown step";
  }
}

class HomeLoanForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: 0,
    };
  }

  handleNext = (ismax) => {
    // console.log('max: ' + ismax)
    if (!ismax) {
      this.setState((state) => ({
        activeStep: state.activeStep + 1,
      }));
    } else {
      if (this.props.displayType === "desktop") {
        this.props.handleClose();
      }
    }
  };

  handleEdit = (step) => {
    this.setState((prevState) => ({
      activeStep: prevState.activeStep - step,
    }));
    window.scrollTo(0, 0);
  };

  handleBack = () => {
    this.setState((state) => ({
      activeStep: state.activeStep - 1,
    }));
  };

  render() {
    const { classes } = this.props;
    const steps = getSteps();
    const maxStep = steps.length - 1;
    const { activeStep } = this.state;
    return (
      <div className="gridContainer">
        <Grid
          container
          className={classnames(classes.spacer, classes.paperPadding)}
        >
          <Stepper activeStep={activeStep} orientation="vertical">
            {steps.map((label, index) => {
              return (
                <Step key={label}>
                  <StepLabel
                    classes={{
                      iconContainer: classes.iconContainer,
                    }}
                  >
                    <Typography
                      style={{
                        color: "#000000",
                        fontWeight: index === activeStep ? "bold" : "normal",
                      }}
                    >
                      {label}
                    </Typography>
                  </StepLabel>
                  <StepContent>
                    <ShowContent
                      step={index}
                      handleBack={this.handleBack}
                      handleSubmit={this.handleNext}
                      handleEdit={this.handleEdit}
                      activeStep={activeStep}
                      maxStep={maxStep}
                    />
                  </StepContent>
                </Step>
              );
            })}
          </Stepper>
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(HomeLoanForm);
